import React, { Component } from 'react';
import { Container, Row, Col, FormControl, Image, Dropdown, DropdownButton, Form, Button, Pagination, ButtonToolbar, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Bounce } from 'react-activity';
import { store } from 'react-notifications-component';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { QRCode } from 'react-qrcode-logo';

import NavbarComponent from '../../Navbar/index';
import RenovateTokenAlert from '../../../RenovateToken';
import Backend from '../../../Backend';
import Connection from '../../../Calls';
import ApiRow from '../../Settings/apiRow'

import EcommOptions from '../ecommOptions'

import {ReactComponent as Check} from '../../../Images/check-solid.svg'
import CopyClip from '../../../Images/copy-clip.png'
import BackArrow from '../../../Images/arrow-left.svg';
import DownloadIcon from '../../../Images/download-icon.svg'

import './index.css';


class EcommerceOnboarding extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showLoad:true,
      coins_settings:{},
      img_base64:'',
      ClipboardText:'Copy to clipboard',
      idTooltip:'',
    }
  }
  addNotification(status,msg,type){
    store.addNotification({
      title: status,
      message: msg,
      type: type,
      insert: "top",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: {
        duration: 2500,
        onScreen: true
      }
    });
  }

  componentWillMount() {
    this.getEcommSettings()
    setTimeout(() => {
      if (this.state.currency === ''){
        this.setState({currency: 'mxn'})
      }
    }, 3000);
  }

  getEcommSettings(){
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.general_get('get_thats_it_settings',response.payload.r01,response=>{
        Object.keys(response.payload).forEach((item, i) => { if(response.payload[item] == '-') response.payload[item] = '' });
        if(response.status.code == '0')  this.setState({ ...response.payload, showLoad:false })
      })

      Backend.get_ecomm_image(response.payload.r01, response =>{
        if(response.status.code == '0')
          this.setState({img_base64:'data:image/png;base64,'+response.payload.img_b64})
      })
    })
  }

  getSettingOptions (){
    let { acceptance_threshold , auto_fiat, fiat_bank, fiat_interval, url, currency } = this.state
    return { acceptance_threshold , auto_fiat, fiat_bank, fiat_interval, url, currency }
  }

  updateEcommSettings(){
    let { identifier, pin, pin_enabled, web_name } = this.state
    let thats_it_settings = { identifier, pin, pin_enabled, web_name }
    let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
    navigator.geolocation.getCurrentPosition((success, error, options) => {
      latitude = success.coords.latitude;
      longitude = success.coords.longitude
    });
    result = latitude + longitude;
    this.setState({showLoad:true})
    Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
      Backend.change_thats_it_settings(response.payload.r01, thats_it_settings,  response => {
        if(response.status.code == '0') this.addNotification("Success!",'Settings updated correctly',"success");
        else this.addNotification("Error!",'Something went wrong, try again later',"danger");
        this.setState({showLoad:false})
      })
    })
  }

  CopyToClipboard(){
    const self=this
    self.setState({ClipboardText:'Copied to clipboard', idTooltip:'tooltip-right fade-in'});
    setTimeout(function(){ self.setState({ idTooltip:' tooltip-right fade-out'}) }, 1000)
    setTimeout(function(){ self.setState({ClipboardText:'Copy to clipboard',idTooltip:''}) }, 2000)
  }
  
  downloadQr() {
    const canvas = document.getElementById("react-qrcode-logo");
    const pngUrl = canvas
    .toDataURL("image/png")
    .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = `ecommerce-${this.state.web_name}-qr.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  validateReference(e){
    const {value} = e.target
    if(value !== '' && value.length > 0){
      let mask = value.replace(/[^A-Za-z0-9 ]+$/g, '')
      this.setState({identifier: mask})
    } else {
      this.setState({identifier: value})
    }
  }

  render(){
    let { ecomm } = this.props.traductions
    let { identifier, pin, pin_enabled, web_name } = this.state
    return(
      <div>
        <NavbarComponent data={this.props} selected="ecommerce" logged={true} />
        <RenovateTokenAlert data={this.props} />
        <div className="contenedor-wallets-generals" style={{ paddingLeft: 10, paddingRight: 10, }}>
          <Container className='ecommerce_signup'>
            <div>
              <div className='back-button' style={{width:110, cursor:'pointer', marginTop:-15, marginBottom:10}} onClick={()=>this.props.data.history.push('/ecommerce')}>
                <Image src={BackArrow} style={{ marginTop:-3, marginRight:10}}/>
                {ecomm.goBack}
              </div>
            </div>
            <p className='dark-text medium-dms text-25'>{ecomm.b_settings}</p>
            <div className='container-transactions'>
              <div className='flex' style={{marginBottom:40}}>
                <div style={{borderRadius:100, height:100, width:100, display:'inline-block', overflow:'hidden', position:'relative'}}>
                  {
                    this.state.img_base64
                    ?<Image style={{height:100, width:100}} src={this.state.img_base64}/>
                    :''
                  }
                </div>
                <div style={{marginLeft:30}}>
                  <p className='font-22 blue-text medium-dms'>{ecomm.myecomm} </p>
                  <p className='font-20 gray-text normal-dms'>{this.state.ecomm} </p>
                </div>
              </div>
              <div>
                <div style={{marginBottom:10}}>
                <OverlayTrigger
                  placement="right"
                  overlay={<Tooltip id="button-tooltip-2">{ecomm.msg_validation}</Tooltip>}
                >
                  <Form.Label className="ecommerce_input_label">{ecomm.refInput}:</Form.Label>
                </OverlayTrigger>
                  <Form.Control
                    style={{ height: 40 }}
                    className="ecommerce_input"
                    type="text"
                    placeholder="Reference"
                    maxLength={18}
                    value={this.state.identifier}
                    onChange={(e) => this.validateReference(e) }
                    />
                </div>
              </div>
              <div className='ecommerce_divider'/>
              <div>
                <div style={{marginBottom:10}}>
                  <Form.Label className="ecommerce_input_label">{ecomm.web_name}:</Form.Label>
                  <div className="ecommerce_input_label" style={{display:'flex', alignItems:'center'}}>
                    https://thatsit.wirebit.com/
                    <Form.Control
                      style={{ height: 40, width: 200}}
                      className="ecommerce_input"
                      type="text"
                      placeholder="bussiness"
                      value={this.state.web_name}
                      onChange={(web_name) => { this.setState({ web_name: web_name.target.value?.toLowerCase() }) }}
                      />
                      <OverlayTrigger 
                        placement={'right'}
                        overlay={
                          <Tooltip className={this.state.idTooltip}>
                            {this.state.ClipboardText}
                          </Tooltip>
                        }
                      >
                        <CopyToClipboard text={`https://thatsit.wirebit.com/${this.state.web_name}`}>
                          <button style={{marginLeft: '10px'}} className='copy-wallets-clipboard' onClick={()=>{ this.CopyToClipboard()}}>
                            <Image src={CopyClip}/>
                          </button>
                        </CopyToClipboard>
                      </OverlayTrigger>
                  </div>
                  <div style={{display: 'flex', justifyContent: 'center', marginTop: '30px', flexDirection: 'column', alignItems:'center'}}>
                    <QRCode
                      id="ecommerce-qr-code"
                      bgColor="#FFFFFF"
                      fgColor="#000000"
                      style={{ width: 150, margin:'auto'}}
                      value={`https://thatsit.wirebit.com/${this.state.web_name}`}
                      logoWidth={70}
                      logoOpacity={0.3}
                      qrStyle={"squares"}
                    /> 
                    <Button variant="link" className='btn-qr-download' onClick={() => this.downloadQr()}>{ecomm.download_btn}
                        <Image className='img-download' src={DownloadIcon}/>
                    </Button>
                  </div>
                </div>
              </div>
              <div className='ecommerce_divider'/>
              <div>
                <div style={{marginBottom:10}}>
                  <div>
                    <Form.Label className="ecommerce_input_label">Pin:</Form.Label>
                    <div className='ecomm-checkbox'>
                      <div className={pin_enabled?'selected':''} onClick={()=>this.setState({pin_enabled:!pin_enabled})}>
                        <Check/>
                      </div>
                      <span className='gray-text normal-dms'>
                        {ecomm.pin_txt}
                      </span>
                    </div>
                  </div>
                  {
                    pin_enabled &&
                    <Form.Control
                      style={{ height: 40 }}
                      className="ecommerce_input"
                      type="number"
                      maxLength="6"
                      placeholder="Pin"
                      value={this.state.pin}
                      onChange={(pin) => { this.setState({ pin: pin.target.value }) }}
                      />

                  }
                </div>
              </div>
              <Button className='ecommerce_signup_button medium-dms' disabled={this.state.showLoad} onClick={()=>this.updateEcommSettings()}>
                {
                  (this.state.showLoad)
                    ? <Bounce size={20} color={"#FFFFFF"} animating={this.state.showload} />
                    : ecomm.save
                }
              </Button>

            </div>

          </Container>
        </div>

      </div>
    )
  }
}
export default EcommerceOnboarding
